var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientSubAdminsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86701 5.61366C6.41718 5.61366 7.67384 4.357 7.67384 2.80683C7.67384 1.25666 6.41718 0 4.86701 0C3.31684 0 2.06018 1.25666 2.06018 2.80683C2.06018 4.357 3.31684 5.61366 4.86701 5.61366Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9544 6.29146C5.94114 6.2911 5.92789 6.29074 5.91464 6.29053H3.8189C1.66973 6.33093 -0.0396988 8.10597 0.000701611 10.2551C0.000916507 10.2684 0.0012747 10.2817 0.00163286 10.2949V10.8937C0.00163286 11.1931 0.113879 11.5299 0.450693 11.5299H9.28285C9.61966 11.5299 9.73191 11.1931 9.73191 10.8937V10.2949C9.7943 8.14623 8.10307 6.35385 5.9544 6.29146Z",
    fill: "#666666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.46521,
    y: 7.99927,
    width: 1.46693,
    height: 4.40078,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99927,
    y: 9.46533,
    width: 4.40078,
    height: 1.46693,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSubAdminsIcon);
export default __webpack_public_path__ + "static/media/client-sub-admins-icon.0af4dab7.svg";
export { ForwardRef as ReactComponent };